<template>
    <el-dialog
        :visible.sync="Visible"
        :title="title"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        v-loading="loading"
        element-loading-text="加载中"
        element-loading-background="rgba(0, 0, 0, 0.1)"
    >
        <el-table
            :data="list"
            size="mini"
            border
            :highlight-current-row="true"
            class="toggletable"
            :cell-class-name="tableCellClassName"
        >
            <el-table-column type="index" label="序号"></el-table-column>
            <el-table-column label="原科目编码" prop="oldSubjectCode"></el-table-column>
            <el-table-column label="原科目名称" prop="oldSubjectName"></el-table-column>
            <el-table-column label="原辅助核算" prop="oldAuxiliaryAccount"></el-table-column>
            <el-table-column label="现科目编码" prop="newSubjectCode"></el-table-column>
            <el-table-column label="现科目名称" prop="newSubjectName"></el-table-column>
            <el-table-column label="现辅助核算" prop="newAuxiliaryAccount"></el-table-column>
            <el-table-column label="错误信息" prop="errorMsg"></el-table-column>
        </el-table>

        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-sizes="[1, 2, 5, 10]"
            :page-size="limit"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
        >
        </el-pagination>
        <span slot="footer" class="dialog-footer">
            <el-button type="info" size="medium" @click="closeSelect" icon="el-icon-close"
                >取 消</el-button
            >
            <el-button type="primary" size="medium" @click="replaceAll" icon="el-icon-check"
                >替 换</el-button
            >
        </span>
    </el-dialog>
</template>

<script>
import SubjectService from "../../services/voucher/SubjectService";
import config from "../../common/config";
import FileSaver from "file-saver";
import XLSX from "xlsx";
export default {
    components: {},
    data() {
        return {
            limit: 5,
            total: null,
            page: 1,
            Visible: false,
            loading: false,
            index: 0,
            title: "",
            tableData: [],
            brandValue: "",
            storeValue: "",
            accountConfInfoValue: "",
            subjectTypeId: "",
            list: [],
        };
    },
    props: {
        Refresh: {
            type: Function,
            required: true,
        },
    },
    methods: {
        // 回调函数
        tableCellClassName({ row, column, rowIndex, columnIndex }) {
            if (columnIndex === 3 || columnIndex === 6) {
                return "warning-cell";
            }
            return "";
        },
        openSelect(checkData, name, data) {
            this.tableData = data;
            this.Visible = true;
            this.title = name + "变动检测结果";
            this.brandValue = checkData.brandId;
            this.accountConfInfoValue = checkData.accountId;
            this.storeValue = checkData.storeId;
            this.subjectTypeId = checkData.subjectTypeId;
            this.getList();
        },
        // 处理数据
        getList() {
            this.list = this.tableData.filter(
                (item, index) =>
                    index < this.page * this.limit && index >= this.limit * (this.page - 1)
            );
            this.total = this.tableData.length;
        },
        // 当每页数量改变
        handleSizeChange(val) {
            this.limit = val;
            this.getList();
        },
        // 当当前页改变
        handleCurrentChange(val) {
            this.page = val;
            this.getList();
        },
        initData(d) {
            this.tableData = d;
        },
        closeSelect() {
            this.Visible = false;
        },
        replaceAll() {
            const _this = this;
            _this
                .$confirm("此操作会将原有科目替换为最新的科目，是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                .then(() => {
                    _this.loading = true;
                    let checkComplateModel = {};
                    checkComplateModel.accountId = _this.accountConfInfoValue;
                    checkComplateModel.brandId = _this.brandValue;
                    checkComplateModel.storeId = _this.storeValue;
                    checkComplateModel.subjectTypeId = _this.subjectTypeId;
                    SubjectService.ReplaceSubjectInfo(checkComplateModel)
                        .then((r) => {
                            if (r.success) {
                                _this.$notify({
                                    title: "成功",
                                    message: "替换成功",
                                    type: "success",
                                    position: "bottom-right",
                                });
                            }
                            _this.Visible = false;
                            _this.loading = false;
                            _this.Refresh();
                        })
                        .catch((e) => {
                            console.log(e);
                        });
                })
                .catch(() => {
                    _this.$notify({
                        type: "info",
                        message: "已取消替换",
                        position: "bottom-right",
                    });
                });
        },
        closeOpenloading() {},
    },
};
</script>

<style>
.el-table .warning-cell {
    color: red !important;
}

.el-table .warning-cell:hover > td {
    color: #bbb !important;
}
.myshowup.el-button {
    border-radius: 16px;
}
.el-append-search {
    background-color: #409eff !important;
    color: #fff !important;
}
.graybg {
    background: #f9f9f9 !important;
}
</style>
